define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"csi",
	"csi/def/Action",
	"csi/heading/Boolean",
	"Sourcing"
], function(declare, domClass, csi, Action, BooleanRen, Sourcing) {
	/**
	 * Determines whether current column is Availability Column
	 */
	const isAllColumn = function(/*Context*/ ctx) {
		const { bSizesOnly } = ctx.view;
		return !bSizesOnly && !ctx.getParam(ctx.PARAM_COLUMN_URL);
	}

	return declare(BooleanRen, {
		canComment: function(/*Context*/ctx, /*Heading*/h) {
			return false;
		},

		getQuerySpec: function(/*Context*/ctx, /*Heading*/h, /*Spec*/spec) {
			return null;
		},

		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			if (isAllColumn(ctx) || ctx.getNodeURL() == ctx.view.selectAllUrl) {
				domClass.add(refNode, "csi-bg-changed");
			}

			return this.inherited(arguments);
		},

		_getAction: function() {
			// summary: return core action rather than attribute action
			return new Action();
		},

		/**
		 * @override
		 * sets availability column to read-only
		 */
		_getRenderAction: function(/*Context*/ctx, /*Heading*/h) {
			const product = ctx.getNodeParent();
			const nodeClass = ctx.getNodeClass();
			if(!product && !nodeClass && ctx.view.getViewNode().$Type !== "MaterialSeasonAvailability" && isAllColumn(ctx)){
				 return null;
			}
			const isColorAllocationEnabled = Sourcing.isProductColorwayAllocationWIP(product);
			if (isAllColumn(ctx) && ctx.view.getViewNode().$Type !== "MaterialSeasonAvailability" && isColorAllocationEnabled) {
				return null;
			}
			return this.inherited(arguments)
		},

		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return value for size and color in context
			var view = ctx.view;
			var node = view.getViewNode();
			var urlColor = view.getContextColor(ctx);
			var urlSize = view.getContextSize(ctx);
			var bColor = (urlColor != csi.EMPTY_URL);
			var bSize = (urlSize != csi.EMPTY_URL);
			var b = node.AvailabilityDefault;

			if (bColor || bSize) {
				if ((bColor && (view.getColorException(node, urlColor) >= 0)) ||
					(bSize && (view.getSizeException(node, urlSize) >= 0))) {
					b = !b;
				}

				if (bColor && bSize && (view.getPairException(node, urlColor, urlSize) >= 0)) {
					b = !b;
				}
			}

			return b;
		}
	});
});